import { createSelector } from '@ngrx/store';

import { EDIT_SHOP_THE_LOOK_FEATURE_KEY } from '../constants';
import { State } from '../main-reducer';
import { selectShopTheLookState } from '../main-selector';

import { EditShopTheLooksState } from './edit-shop-the-look-reducer';

export const selectEditLookBooksState = createSelector(
  selectShopTheLookState,
  (state: State) => state[EDIT_SHOP_THE_LOOK_FEATURE_KEY],
);
/**
 * Selector to get all the lookBooks
 */
export const selectSelectedLookBookItemsToEdit = createSelector(
  selectEditLookBooksState,
  (state: EditShopTheLooksState) => state.selectedLookBookItems,
);

/**
 * Selector to get all the lookBooks
 */
export const selectLookBookForEdit = createSelector(
  selectEditLookBooksState,
  (state: EditShopTheLooksState) => state.lookBook,
);

export const selectEditLookBookLoading = createSelector(
  selectEditLookBooksState,
  (state: EditShopTheLooksState) => state.lookBookLoading,
);

export const selectEditLookBookError = createSelector(
  selectEditLookBooksState,
  (state: EditShopTheLooksState) => state.lookBookError,
);
